const affiliateTypes = {
  RESET_AFFILIATE_STATE: 'RESET_AFFILIATE_STATE',
  CREATE_AFFILIATE: {
    REQUEST: 'CREATE_AFFILIATE_REQUEST',
    SUCCESS: 'CREATE_AFFILIATE_SUCCESS',
    FAILURE: 'CREATE_AFFILIATE_FAILURE',
  },
  UPDATE_AFFILIATE: {
    REQUEST: 'UPDATE_AFFILIATE_REQUEST',
    SUCCESS: 'UPDATE_AFFILIATE_SUCCESS',
    FAILURE: 'UPDATE_AFFILIATE_FAILURE',
  },
  SYNC_AFFILIATES: {
    REQUEST: 'SYNC_AFFILIATES_REQUEST',
    SUCCESS: 'SYNC_AFFILIATES_SUCCESS',
    FAILURE: 'SYNC_AFFILIATES_FAILURE',
  },
};

export default affiliateTypes;
